<script>
   /*************************************************************/
   /* Svelte component for changing SIMCA settings              */
   /*************************************************************/

   import { pcamodel_get } from '@mdatools-apps/wasm/pca.js';

   // main properties of the whole app
   let {model, simca, isAlt = false} = $props();


   let lt = $derived(simca ? (simca.limType === 'classic' ? 'c' : 'r') : null);
   let Nh = $derived(model && lt ? pcamodel_get(model, lt + 'Nh') : null);
   let Nq = $derived(model && lt ? pcamodel_get(model, lt + 'Nq') : null);
   let h0 = $derived(model && lt ? pcamodel_get(model, lt + 'h0') : null);
   let q0 = $derived(model && lt ? pcamodel_get(model, lt + 'q0') : null);

   let ncomp = $derived(simca ? simca.ncomp : null)

</script>


{#if model && simca && ncomp > 0}
<table>
   <thead>
   <tr>
      <th></th>
      <th>h</th>
      <th>q</th>
      <th>f</th>
   </tr>
   </thead>
   <tbody>
   <tr>
      <td class="label">DoF (Nu)</td>
      <td>{Nh[ncomp - 1]}</td>
      <td>{Nq[ncomp - 1]}</td>
      <td>{Nh[ncomp - 1] + Nq[ncomp - 1]}</td>
   </tr>
   <tr>
      <td class="label">Mean (u0)</td>
      <td>{h0[ncomp - 1].toFixed(3)}</td>
      <td>{q0[ncomp - 1].toFixed(q0[ncomp - 1] > 99 ? 0 : 3)}</td>
      <td></td>
   </tr>
   <tr>
      <td class="label">Crit (extreme)</td>
      <td></td>
      <td></td>
      <td>{simca.eCrit[ncomp - 1].toFixed(1)}</td>
   </tr>
   {#if !isAlt}
   <tr>
      <td class="label">Crit (outliers)</td>
      <td></td>
      <td></td>
      <td>{simca.oCrit[ncomp - 1].toFixed(1)}</td>
   </tr>
   {/if}
   </tbody>
</table>
{/if}

<style>
   table {
      width: 100%;
      border-collapse: collapse;
   }

   tr {
      width: 100%;
   }

   th {
      border-bottom: 1px solid #a0a0a0;
   }

   th, td {
      text-align: right;
      padding: 0.2em 0.5em 0.2em 0.1em;
      color: #404040;
      margin: 0;
   }

   .label {
      text-align: left;
      padding: 0.1em 0.5em;
   }
</style>